export default __webpack_public_path__ + "static/media/crwn.ddf7dba8.png";